/**
 * ModalPortal — fixed overlay rendered at document.body (above .pm slide-over).
 */

import { type ReactNode } from 'react'
import { createPortal } from 'react-dom'

export const MODAL_OVERLAY_Z = 620

export const modalOverlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(9,9,11,.45)',
  backdropFilter: 'blur(2px)',
  zIndex: MODAL_OVERLAY_Z,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
}

export const modalBoxStyle: React.CSSProperties = {
  background: 'var(--surface)',
  borderRadius: 'var(--rs)',
  maxWidth: 480,
  width: '100%',
  boxShadow: '0 20px 60px rgba(0,0,0,.2)',
  maxHeight: '90vh',
  overflow: 'auto',
}

interface Props {
  children: ReactNode
  onBackdropClick?: () => void
  testId?: string
}

export default function ModalPortal({ children, onBackdropClick, testId }: Props) {
  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      style={modalOverlayStyle}
      onClick={(e) => { if (e.target === e.currentTarget) onBackdropClick?.() }}
      data-testid={testId}
    >
      {children}
    </div>,
    document.body,
  )
}
